var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"panel-active"}},[(_vm.showGamePanel)?_c('div',{staticClass:"panel",attrs:{"id":"game"}},[_c('GameHeader'),_c('GameContent'),_c('GameButtons')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }